<template>
  <div class="markdown-block" @click="onClick">
    <div class="markdown-body" v-html="html"></div>
    <LinkCard v-for="link in cardLinks" :key="link" :url="link" />
  </div>
</template>

<script>
import { extractMarkdownLinks, renderMarkdown } from '@/utils/markdown'
import LinkCard from './LinkCard.vue'
import { useUiStore } from '@/store/ui'

export default {
  name: 'MarkdownBody',
  components: { LinkCard },
  props: {
    content: { type: String, default: '' },
    maxCards: { type: Number, default: 1 },
  },
  computed: {
    html() {
      return renderMarkdown(this.content || '')
    },
    cardLinks() {
      return extractMarkdownLinks(this.content || '').slice(0, this.maxCards)
    },
  },
  methods: {
    // 拦截 @ 提及链接（<a class="mention" href="/u/123">）：弹用户资料卡，而非整页跳转
    onClick(e) {
      const a = e.target.closest && e.target.closest('a.mention')
      if (!a) return
      const m = (a.getAttribute('href') || '').match(/^\/u\/(\d+)/)
      if (!m) return
      e.preventDefault()
      e.stopPropagation()
      useUiStore().openProfileCard({ id: Number(m[1]) }, a)
    },
  },
}
</script>
